<template>
	<div>
		<app-table
			class="is-not-selectable no-main-list"
			:columns="columns"
			:rows="rows"
			:filter-columns="false"
			title="PROCESOS"
			:last-page="lastPage"
			:items-total-quantity="totalItems"
			:current-page="currentPage"
			btn-actions
			@on-page="changePage"
			@on-search-event="onSearchEvent"
			@changeSort="changeSort"
			@changeColor="changeColor">
			<template slot="action">
				<v-btn
					class="btn-action-process"
					@click="goTo('new-recruitment')">
					Nuevo Reclutamiento
				</v-btn>
			</template>
			<template slot="rows" slot-scope="props">
				<td class="start-row" v-show="showRow(columns, 1)">{{ props.row.steps.config[0].details.name }} ({{ props.row.job ? props.row.job.name : '' }})</td>
				<td v-show="showRow(columns, 2)">{{ props.row.steps.config[0].details.hireDate | formatDate }}</td>
				<td style="text-align: center !important;" v-show="showRow(columns, 3)">{{ props.row.steps.config[0].details.vacancyNumber }}</td>
				<td style="text-align: center !important;" v-show="showRow(columns, 4)">{{ props.row.recruitmentApplicant.length }}</td>
				<td style="text-align: center !important;" v-show="showRow(columns, 5)">{{ numFinalistApplicant(props.row.recruitmentApplicant) }}</td>
				<td v-show="showRow(columns, 6)">
					{{ statusName(props.row.status) }}
					<app-tooltip-button
						img="/static/img/change-status.svg"
						size="14"
						text="Cambiar Estado"
						@click-icon="handlerChangeStatusProcess(props.row)"
					/>
				</td>
				<td v-show="showRow(columns, 7)" @click.stop="stopClick">
					<v-layout wrap>
						<app-tooltip-button
							img="/static/img/file-view.svg"
							text="Ver Descripción del Puesto"
							@click-icon="handlerDescriptionProcess(props.row)"
						/>
						<app-tooltip-button
							img="/static/img/news.svg"
							text="Ver Anuncio"
							:disabled="diabledBtn"
							@click-icon="handlerSeeAdvertisement(props.row)"
						/>
						<v-menu
							offset-x
							rigth
							:nudge-rigth="97"
							fixed
							content-class="columns-menu-v2"
							class="options-menu-v2">
							<button
								color="transparent"
								slot="activator">
								<v-tooltip top>
									<img
										src="/static/img/ellipsis.svg"
										alt=""
										slot="activator"
										class="align-img tw-pt-3 tw-pl-3"
										height="24">
									<span>Ver más</span>
								</v-tooltip>
							</button>
							<v-list class="list-menu">
								<v-list-tile>
									<p-item-list
										img="/static/img/edit.svg"
										text="Editar"
										@click="handleEditRecruitment(props.row)"
									></p-item-list>
								</v-list-tile>
								<v-list-tile>
									<p-item-list
										img="/static/img/groups.svg"
										text="Ver Postulantes"
										@click="handleShowApplicants(props.row)"
									></p-item-list>
								</v-list-tile>
								<v-list-tile>
									<p-item-list
										img="/static/img/clone.svg"
										text="Clonar"
										size="20"
										@click="handleCloneRecruitment(props.row)"
									></p-item-list>
								</v-list-tile>
								<v-list-tile>
									<!-- <app-tooltip-button
										img="/static/img/pdf.svg"
										text="Descargar Reporte"
										size="20"
										@click-icon="handleReportRecruitment(props.row)"
									/> -->
									<p-item-list
										img="/static/img/deletev1.svg"
										text="Eliminar"
										size="20"
										@click="handleDeleteRecruitment(props.row)"
									></p-item-list>
								</v-list-tile>
								<v-list-tile>
									<p-item-list
										img="/static/img/link.svg"
										text="Generar Enlace"
										class="copy-button"
										@click="handleGenerateLink(props.row)"
									></p-item-list>
								</v-list-tile>
							</v-list>
						</v-menu>
					</v-layout>
				</td>
			</template>
		</app-table>
		<change-status-dialog
			ref="changeStatus"
			:status="focusedProcess.status"
			@changeValueStatus="updateValueStatus">
		</change-status-dialog>
		<confirm-dialog ref="confirmDialog" />
	</div>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PButton from '@/modules/shared/components/ui/p-button';
import PItemList from '@/modules/shared/components/ui/p-item-list';
import changeStatusDialog from '@/modules/recruitment/components/content/change-status-dialog';
import ConfirmDialog from '@/modules/shared/components/ui/ConfirmDialog';
import FileSaver from 'file-saver';
import 'pdfjs-dist/web/pdf_viewer.css';
import helper from '@/shared/helper';
import bus from '@/bus/app-bus';
import { MAIN_LOADER_EVENT } from '@/modules/shared/components/ui/p-main-loader.constants';
import * as pdfjsLib from 'pdfjs-dist';
import Clipboard from 'clipboard';

// const { generateBlob, showDownloadDialog } = helper;

pdfjsLib.GlobalWorkerOptions.workerSrc =
    'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.6.347/build/pdf.worker.min.js';

export default {
	name: 'page-list-process-recruitment',
	data() {
		return {
			columns: [
				{
					id: 1,
					name: 'PROCESO DE SELECCIÓN',
					value: 'name',
					visible: true,
					checked: true,
					sortCheck: true,
					fieldName: 'name',
					color: 'gray',
				},
				{
					id: 2,
					name: 'F. CONTRATACIÓN',
					value: 'hireDate',
					visible: true,
				},
				{
					id: 3,
					name: 'NRO. VACANTES',
					value: 'vacancyNumber',
					visible: true,
				},
				{
					id: 4,
					name: 'POSTULANTES',
					value: 'applicants',
					visible: true,
				},
				{
					id: 5,
					name: 'FINALISTAS',
					value: 'finalists',
					visible: true,
				},
				{
					id: 6,
					name: 'ESTADO',
					value: 'state',
					visible: true,
				},
				{
					id: 7,
					name: 'ACCIONES',
					value: 'actions',
					visible: true,
				},
			],
			params: {
				page: 1,
				limit: 10,
			},
			rows: [],
			lastPage: 0,
			totalItems: 0,
			currentPage: 1,
			focusedProcess: {},
			pdfBase64: '',
			diabledBtn: false,
		};
	},
	components: {
		PCard,
		PButton,
		PItemList,
		changeStatusDialog,
		ConfirmDialog,
	},
	beforeCreate() {
		this.$store.dispatch('recruitment/flagDisabledButton', false);
	},
	created() {
		this.loadProcessRecruitments();
	},
	methods: {
		async loadProcessRecruitments() {
			const params = {
				...this.params,
			};
			try {
				const { data: response, headers } = await this.$httpPraktiko.get('recruitment', { params });
				this.rows = response;
				this.lastPage = Number(headers['x-last-page']);
				this.totalItems = Number(headers['x-quantity']);
			} catch (error) {
				this.showGenericError();
			}
		},
		changeColor(fieldName) {
			this.columns.forEach((c, index) => {
				if (c.fieldName !== fieldName && c.color) {
					this.$set(this.columns, index, { ...c, color: 'gray' });
				}
			});
		},
		changeSort({ fieldName, sortDirection }) {
			this.params.sortField = fieldName;
			this.params.sortDirection = sortDirection;
			this.loadProcessRecruitments();
		},
		changePage(page) {
			this.params.page = page;
			this.currentPage = page;
			this.loadProcessRecruitments();
		},
		onSearchEvent(search) {
			this.params.search = search.trim() || null;
			this.changePage(1);
		},
		handleEditRecruitment(row) {
			this.$store.dispatch('recruitment/saveIdConfigProcess', row.id);
			this.$store.dispatch('recruitment/toggleJobSelection', row.job);
			this.$store.dispatch('recruitment/flagDisabledButton', true);
			const code = 'CPR';
			this.$store.dispatch('recruitment/loadConfigProcess', code);
			setTimeout(() => {
				this.goTo('config-process-recruitment');
			}, 1000);
		},
		handleShowApplicants(row) {
			this.$store.dispatch('recruitment/dataProcessSelected', row);
			this.goTo('list-applicants');
		},
		async handleCloneRecruitment(row) {
			const { steps, jobId } = row;
			const nameProcess = `${steps.config[0].details.name} ${'(copia)'}`;
			steps.config[0].details.name = nameProcess;
			const body = {
				steps,
				jobId,
			};
			try {
				await this.$httpPraktiko.post('/recruitment/clone', body);
				this.showNotification(`El proceso ${steps.config[0].details.name} se clono correctamente`);
				this.loadProcessRecruitments();
			} catch (error) {
				this.showGenericError();
			}
		},
		// async handleReportRecruitment(row, contentType) {
		// 	const body = {
		// 		id: row.id,
		// 	};
		// 	try {
		// 		const code = 'recruitment';
		// 		const { data: pdfData } = await this.$httpPraktiko
		// .post(`reports/recruitments-process/${code}/pdf`, body, { responseType: 'blob' });
		// 		const blob = generateBlob(pdfData, contentType);
		// 		showDownloadDialog(blob, 'Reporte_Reclutamiento', 'pdf');
		// 	} catch (error) {
		// 		this.showGenericError();
		// 	}
		// },
		async handleDeleteRecruitment(row) {
			this.$refs.confirmDialog.showConfirm({
				onOk: async () => {
					try {
						await this.$httpPraktiko.delete(`/recruitment/delete/${row.id}`);
						this.showNotification(`El proceso ${row.steps.config[0].details.name} se elimino correctamente`);
						this.loadProcessRecruitments();
					} catch (error) {
						this.showGenericError();
					}
				},
				title: `¿Seguro que desea eliminar el proceso ${row.steps.config[0].details.name}  del listado?`,
			});
		},
		handleGenerateLink(row) {
			const userInfo = helper.getLocalData('praktiko-user');
			const { company } = userInfo;
			const customLink = `https://admin.praktiko.tech/applications-form/${row.id}/${company.aclCode}/${company.id}`;
			const clipboard = new Clipboard('.copy-button', {
				text: () => customLink,
			});
			clipboard.on('success', () => {
				this.showNotification('Enlace Copiado');
				clipboard.destroy();
			});
			clipboard.on('error', (e) => {
				this.showGenericError();
				console.error(e);
				clipboard.destroy();
			});
			clipboard.onClick({ currentTarget: document.querySelector('.copy-button') });
		},
		handlerDescriptionProcess(row) {
			this.$store.dispatch('jobProfile/saveJobSelected', row.job);
			this.$store.dispatch('recruitment/flagDisabledButton', true);
			this.goTo('job-view-details', { params: { id: row.job.id } });
		},
		async handlerSeeAdvertisement(row) {
			const body = {
				id: row.id,
			};
			bus.$emit(MAIN_LOADER_EVENT, { show: true, message: 'Procesando...' });
			this.diabledBtn = true;
			try {
				({ data: this.pdfBase64 } = await this.$httpPraktiko.post('reports/advertisement/advertisement/pdf', body, { responseType: 'blob' }));
				if (this.pdfBase64) {
					const blobUrl = URL.createObjectURL(this.pdfBase64);
					const loadingTask = pdfjsLib.getDocument(blobUrl);
					loadingTask.promise
						.then((pdfDocument) => {
							const totalPages = pdfDocument.numPages;
							const canvasList = [];
							// Itera sobre cada página del PDF
							for (let pageNumber = 1; pageNumber <= totalPages; pageNumber += 1) {
								pdfDocument.getPage(pageNumber).then((page) => {
									const viewport = page.getViewport({ scale: 1.5 });
									const canvas = document.createElement('canvas');
									const context = canvas.getContext('2d');
									canvas.width = viewport.width;
									canvas.height = viewport.height;

									const renderTask = page.render({ canvasContext: context, viewport });

									renderTask.promise.then(() => {
										const imageDataURL = canvas.toDataURL();
										canvasList.push(imageDataURL);

										if (canvasList.length === totalPages) {
											canvasList.forEach((imageData, index) => {
												const arr = imageData.split(',');
												const mime = arr[0].match(/:(.*?);/)[1];
												const bstr = atob(arr[1]);
												let n = bstr.length;
												const u8arr = new Uint8Array(n);
												// eslint-disable-next-line
												while (n--) {
													u8arr[n] = bstr.charCodeAt(n);
												}
												const blob = new Blob([u8arr], { type: mime });
												FileSaver.saveAs(blob, `page_${index + 1}.jpeg`);
											});
										}
									});
								});
							}
						})
						.catch((error) => {
							this.showGenericError(error);
						});
				}
			} catch (error) {
				this.showGenericError();
			} finally {
				bus.$emit(MAIN_LOADER_EVENT, { show: false });
				this.diabledBtn = false;
			}
		},
		handlerChangeStatusProcess(row) {
			this.focusedProcess = row;
			this.$refs.changeStatus.open();
		},
		numFinalistApplicant(applicants) {
			const finalistApplicants = applicants
				.filter(r => r.additionalInformation.typeApplicant.id === 270);
			return finalistApplicants.length;
		},
		statusName(status) {
			let name = '';
			if (status === 0) {
				name = 'Borrador';
			} else if (status === 1) {
				name = 'Publicado';
			} else if (status === 2) {
				name = 'Finalizado';
			}
			return name;
		},
		async updateValueStatus(value) {
			const body = {
				id: this.focusedProcess.id,
				jobId: this.focusedProcess.jobId,
				typeRecruitmentCode: 'CPR',
				details: this.focusedProcess.steps.config[0].details,
				status: value,
			};
			const nameProcess = this.focusedProcess.steps.config[0].details.name;
			try {
				await this.$httpPraktiko.post('/recruitment', body);
				this.showNotification(`Estado de Proceso "${nameProcess}" Actualizado`);
				this.loadProcessRecruitments();
			} catch (error) {
				this.showGenericError();
			}
		},
	},
	computed: {
		totalItemsVisible() {
			return this.rows.length;
		},
	},
};
</script>

<style lang="scss" scoped>
.start-row {
	width: 300px !important;
	text-align: left !important;
	padding-left: 40px !important;
}
.btn-action-process {
	border-radius: 28px !important;
	box-shadow: none !important;
	color: color(white) !important;
	height: 35px !important;
	margin: 0px;
	text-transform: none !important;
	font-family: map-get($fonts, bold);
	width: 140px !important;
	background-color: map-get($colors, green-dark) !important;

	&:hover {
	background-color: map-get($colors, orange-dark) !important;
	}
	.v-btn__content {
		color: color(white) !important;
		// font-family: map-get($fonts, bold);
		padding: 0px;

		img {
			height: auto;
			margin-right: 19px;
		}
	}

	&:not(.btn-detail-close) {
		.v-btn__content {
			font-size: size(medium);
		}
	}

	&.text-large {
		.btn__content {
			font-family: map-get($fonts, open-bold);
			font-size: map-get($sizes, small);
		}
	}
	&.v-btn--disabled {
		background: #9b9b9b !important;
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/recruitment/pages/page-list-process-recruitment.vue